<template>

    <!-- 头部操作 -->
    <!-- <OperateButton v-if="buttonList.length > 0" :buttons="buttonList" /> -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
        <el-button type="primary" size="large" @click="addBackground"
        ><el-icon><Plus /></el-icon>&nbsp;添加</el-button
        >
        <el-button type="primary" @click="editFnc" class="edit" plain size="large"
            ><el-icon><Edit /></el-icon>&nbsp;编辑</el-button
        >
        <el-button type="danger" size="large" v-if="isDelect" plain @click="deletes"
        ><el-icon><Delete /></el-icon>&nbsp;删除</el-button
        >
    </el-button-group>


     <!-- 表格组件 -->
     <div class="DutyTeacher">
        <TableList
            componentTableId="DutyTeacherList"
            @update-list="updateList"
            excelName="老师列表"
            :table-data="tableData"
            :header-data="headerData"
            :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
            :loading="loading"
            :loading-text="loadingText"
            :empty-text="emptyText"
            @searchFnc="searchFnc"
            @openContent="openContent"
            @handleSelection="handleSelection"
            @changeCascader="changeCascader"
            @changeRelevance="changeRelevance"
        >
             <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
        <template #weiXinUrlCustom="scope">
            <el-image
                v-if="scope.scope.weiXinUrl != null && scope.scope.weiXinUrl != ''"
                style="width: 20px; height: 20px; border: 1px solid #dcdfe6"
                title="点击查看大图"
                :src="scope.scope.weiXinUrl"
                :preview-src-list="[scope.scope.weiXinUrl]"
                preview-teleported
            >
            </el-image>&nbsp; 
    
        </template>
        </TableList>
     </div>
  

  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  ></Pagination>

  <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      v-if="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :before-close="beforeDialog"
      top="13vh"
      draggable
                  destroy-on-close
    >
      <div class="dialog_div">
        <add-edit-teacher
          ref="addEditBackground"
          v-if="dialogVisible"
          @close-dialog="closeDialog"
          :editId="editId"
          @update-list="updateList(1)"
          :imgObj="imgObj"
        >
        </add-edit-teacher>
      </div>
    </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, toRefs, ref, toRaw, h, computed, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {GetTeacherList, RemoveTeacherById} from "@/network/teacherScheduling.js";
import AddEditTeacher from "views/dutyTeacher/AddEditTeacher.vue";
import store from "../../store/index";
export default {
    name: "DutyTeacher",
    props: {
        tableMaxHeight: Number,
    },
    components: {
        TableList,
        Pagination,
        AddEditTeacher,
    },
    setup() {
        //这里定义一个结构体，用来保存项目信息
        const data = reactive({
        isDelect: computed(() => {
            return (
            store.state.isDelect ||
            JSON.parse(sessionStorage.getItem("isDelect"))
            );
        }),
        // 表格是否在加载中
        loading: true,
        loadingText: "加载中...",
        emptyText: "暂无数据",
        // 分页
        pagination: {
            currentPage: 1,
            pageSize: 20,
            total: 0,
        },
        //筛选项
        search: {
          Name: '',
          QqNumber: null,
          TelNumber: null
        },
        //表格数据
        tableData: [],
        //表头数据
        headerData: [
            {
            label: "勾选框",
            type: "selection",
            width: "55",
            fixed: "left",
            },
            {
            label: "编号",
            prop: "id",
            width: "60",
            align: "center",
            noSetText: "未设置",
            fixed: "left",
            },
            {
            label: "姓名",
            prop: "name",
            width: "150",
            align: "left",
            noSetText: "未设置",
            type: "InputSearch",
            fixed: "left",
            },
            {
            label: "QQ号码",
            prop: "qqNumber",
            width: "150",
            align: "center",
            noSetText: "未设置",
            type: "InputSearch",
            },
            {
            label: "QQ链接",
            prop: "qqUrl",
            width: "300",
            align: "center",
            noSetText: "未设置",
            },
            {
            label: "电话号码",
            prop: "telNumber",
            width: "150",
            align: "center",
            noSetText: "未设置",
            type: "InputSearch",
            },
            {
            label: "微信二维码图片",
            prop: "weiXinUrl",
            align: "center",
            noSetText: "未设置",
            width: "160",
            custom: true,
            },
            {
            label: "创建人",
            prop: "adminName",
            width: "160",
            align: "center",
            noSetText: "未设置",
            },

            {
            label: "创建时间",
            prop: "createTime",
            width: "240",
            align: "center",
            noSetText: "未设置",
            },
            {
            label: "备注",
            prop: "remarks",
            minWidth: "240",
            fixed: "right",
            align: "center",
            noSetText: "未设置",
            }
           
        ],
        multipleSelection: [], //选中行数据
        dialogTitle: "",
        dialogVisible: false, //添加编辑弹窗
        editId: 0,
        imgObj: {}, //编辑对象
        });


        //挂载后调用函数获取项目数据
        onMounted(() => {
            getData(); 
            // getOperationList();
        });


        // 获取列表
        const getData = async () => {
            data.loading = true;
            const obj = {
                Name: data.search.Name,
                QqNumber: data.search.QqNumber,
                TelNumber: data.search.TelNumber,
                pageIndex: data.pagination.currentPage,
                pageSize: data.pagination.pageSize,
            };
            const res = await GetTeacherList(obj);
            data.loading = false;
            if (res && res.code == 1) {
                data.pagination.total = res.totalCount;
                data.tableData = res.data;
            } else {
                data.loading = false;
                ElMessage.error(res.message);
            }
           
        };

        // 搜索
        const searchFnc = (val) => {
            if (val.prop && val.prop == "name") {
                data.search.Name = val.value;
            }
            if (val.prop && val.prop == "qqNumber") {
                data.search.QqNumber = val.value;
            }
            if (val.prop && val.prop == "telNumber") {
                data.search.TelNumber = val.value;
            }
            data.pagination.currentPage = 1;
            getData();
        };

        //更新列表
        const updateList = (type) => {
            if(type == 1){
               data.search.Name = ''
               data.search.QqNumber = null
               data.search.TelNumber = null
            }
            getData();
        };


        // 分页
        const changePagination = (val) => {
            data.pagination = toRaw(val);
            updateList();
        };

        // 表格多选行处理
        const handleSelection = (row) => {
            data.multipleSelection = JSON.parse(JSON.stringify(row));
        };

        // 删除
        const deletes = () => {
            if (data.multipleSelection.length == 0) {
                ElMessage.error("请先选择老师信息！");
                return;
            }
            if (data.multipleSelection.length > 1) {
                ElMessage.error("一次只能删除一位老师信息！");
                return;
            }
            const id = data.multipleSelection[0].id
            ElMessageBox({
                title: "删除提示",
                message: h("p", null, [
                    h("span", null, "确定要删除老师信息吗？"),
                ]),
                showCancelButton: true,
                cancelButtonText: "取消",
                confirmButtonText: "确认",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        // 开启按钮加载
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = "确认中",
                        // 删除接口
                        RemoveTeacherById(id)
                        .then((result) => {
                        if (result && result.code == 1) {
                            done();
                            ElMessageBox.alert(result.message, "提示", {
                            confirmButtonText: "确认",
                            });
                            updateList();
                        } else {
                            done();
                            ElMessageBox.alert(result.message, "提示", {
                            confirmButtonText: "确认",
                            });
                        }
                        })
                        .catch((err) => {
                        done();
                            ElMessageBox.alert(err.message, "提示", {
                            confirmButtonText: "确认",
                            });
                        })
                    } else {
                        done();
                    }
                },
            }).catch(() => {
                ElMessage("取消删除");
            });
        };

        // 添加
        const addBackground = () => {
            data.imgObj ={};
            data.editId = 0;
            data.dialogTitle = "添加老师";
            data.dialogVisible = true;
        };

        //编辑
        const editFnc = () => {
            if (data.multipleSelection.length == 0) {
                ElMessage.error("请先选择老师信息！");
                return;
            }
            if (data.multipleSelection.length > 1) {
                ElMessage.error("一次只能编辑一位老师信息！");
                return;
            }
            data.dialogVisible = true;
            data.dialogTitle = "编辑老师";
            data.editId = data.multipleSelection[0].id;
            data.imgObj = data.multipleSelection[0]
        }

        // 外层取消按钮
        const beforeDialog = () => {
            addEditBackground.value.onCancel();
            data.dialogVisible = false;
        };

        const closeDialog = () => {
            data.dialogVisible = false;
            data.imgObj = {};
        }

        //关闭添加编辑弹窗操作
        const addEditBackground = ref();
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
        return {
        //解构Data结构体，让模板可以直接调用Data里面的对象
        ...toRefs(data),
        addEditBackground,
        closeDialog,
        beforeDialog,
        // editBackground,
        editFnc,
        addBackground,
        deletes,
        handleSelection,
        changePagination,
        searchFnc,
        getData,
        updateList,
        btnInTable,
        btnLeftList,
        buttonList,
        btnOnList,
        btnHandle,
        doEvent,
        };


    }
}
</script>

<style>
.DutyTeacher tr{
    height: 48.86px;
}
</style>